"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var DEFAULT_TIMEOUT = 60000; // One Minute
exports.substituteParams = function (str, params) { return (params !== undefined ? Object.keys(params).reduce(function (current, key) { return current.replace("{" + key + "}", params[key]); }, str) : str); };
var startFetch = function (key, method, timeout) { return ({ type: constants_1.FETCH_URL_START, key: key, method: method, timeout: timeout }); };
var successFetch = function (key, method, result, statusCode) { return ({ type: constants_1.FETCH_URL_SUCCESS, key: key, method: method, result: result, statusCode: statusCode }); };
var failFetch = function (key, method, error, statusCode) { return ({ type: constants_1.FETCH_URL_FAILED, key: key, method: method, error: error, statusCode: statusCode }); };
exports.resetState = function (key, method) { return ({ type: constants_1.FETCH_URL_RESET, key: key, method: method }); };
var APIClient = /** @class */ (function () {
    function APIClient(url, key, method, substitutions, authStrategy) {
        this.authStrategy = authStrategy;
        this.url = exports.substituteParams(url, substitutions);
        this.key = exports.substituteParams(key, substitutions);
        this.method = method;
    }
    APIClient.prototype.getKey = function () {
        return this.key;
    };
    APIClient.prototype.getMethod = function () {
        return this.method;
    };
    APIClient.prototype.getUrl = function () {
        return this.url;
    };
    APIClient.prototype.request = function (force, timeout, body) {
        var _this = this;
        if (force === void 0) { force = false; }
        if (timeout === void 0) { timeout = DEFAULT_TIMEOUT; }
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var initial, retry, response, requestOptions, request, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch(startFetch(this.key, this.method, Date.now() + timeout));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 14, , 16]);
                        initial = true;
                        retry = false;
                        response = {};
                        _a.label = 2;
                    case 2:
                        if (!(initial === true || retry === true)) return [3 /*break*/, 13];
                        // After the initial run, only run again if retry is true.
                        initial = false;
                        retry = false;
                        requestOptions = this.authStrategy.getRequestOptions(this.method, body);
                        return [4 /*yield*/, fetch(this.url, requestOptions)];
                    case 3:
                        request = _a.sent();
                        if (!(request.status > 299)) return [3 /*break*/, 10];
                        if (!(request.status === 401)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.authStrategy.onUnauthorized(dispatch, getState, request)];
                    case 4:
                        retry = _a.sent();
                        return [3 /*break*/, 9];
                    case 5:
                        if (!(request.status === 403)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.authStrategy.onForbidden(dispatch, getState, request)];
                    case 6:
                        retry = _a.sent();
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, request.json()];
                    case 8:
                        response = _a.sent();
                        dispatch(failFetch(this.key, this.method, response, request.status));
                        _a.label = 9;
                    case 9: return [3 /*break*/, 12];
                    case 10: return [4 /*yield*/, request.json()];
                    case 11:
                        response = _a.sent();
                        dispatch(successFetch(this.key, this.method, response, request.status));
                        _a.label = 12;
                    case 12: return [3 /*break*/, 2];
                    case 13: return [2 /*return*/, response];
                    case 14:
                        e_1 = _a.sent();
                        return [4 /*yield*/, this.authStrategy.onUnauthorized(dispatch, getState, e_1)];
                    case 15:
                        _a.sent();
                        return [3 /*break*/, 16];
                    case 16: return [2 /*return*/];
                }
            });
        }); };
    };
    return APIClient;
}());
exports.APIClient = APIClient;
